import { AxiosInstance } from 'axios';
import EventsRepositoryInterface, {
  CreateEventsInterface,
  EventsInterface, UpdateEventsInterface,
} from '@/services/Calendar/Events/Interfaces';

export default class EventsRepository implements EventsRepositoryInterface {
  private apiPrefix = '/event-calendar/event';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getEventsForCurrentMonth(): Promise<EventsInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async getEvent(id: number): Promise<EventsInterface> {
    const res = await this.axios.get(`${this.apiPrefix}/event/${id}`);

    return res.data;
  }

  public async getEventsFromRangeOfDates(start: Date, end: Date): Promise<EventsInterface[]> {
    const res = await this.axios
      .get(`${this.apiPrefix}/range/${start.toISOString().substr(0, 10)}/${end.toISOString().substr(0, 10)}`);

    return res.data;
  }

  public async getEventsForMonth(year: number, month: number): Promise<EventsInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}/month/${year}/${month}`);

    return res.data;
  }

  public async getEventsForQuarter(year: number, quarter: number): Promise<EventsInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}/quarter/${year}/${quarter}`);

    return res.data;
  }

  public async getEventsForYear(year: number): Promise<EventsInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}/year/${year}`);

    return res.data;
  }

  public async getAllEventsForCurrentYear(): Promise<EventsInterface[]> {
    return this.getEventsForYear((new Date()).getFullYear());
  }

  public async createEvent(data: CreateEventsInterface): Promise<EventsInterface> {
    const res = await this.axios.post(this.apiPrefix, data);

    return res.data;
  }

  public async updateEvent(data: UpdateEventsInterface): Promise<void> {
    await this.axios.patch(this.apiPrefix, data);
  }

  public async deleteEvent(id: number): Promise<void> {
    await this.axios.delete(this.apiPrefix, { data: { id } });
  }
}
